import deepak from "../assets/images/officeBearers/deepak.webp";
import vishnupriya from "../assets/images/officeBearers/vishnupriya.jpg";
import ramya from "../assets/images/officeBearers/ramya.webp";
import sharvesh from "../assets/images/officeBearers/sharvesh.jpg";
import ganesh from "../assets/images/officeBearers/ganesh.webp";
import bharani from "../assets/images/officeBearers/bharani.jpg";
import bharathi from "../assets/images/officeBearers/bharathi.jpg";

const ObDetails = [
  {
    name: "Deepak R",
    designation: "President",
    photo: deepak,
    linkedin: "https://www.linkedin.com/in/deepak-r-54251925a/",
  },
  {
    name: "Bharani M",
    designation: "Vice-President",
    photo: bharani,
    
  },
  {
    name: "Ramya Nandakumar",
    designation: "Vice-President",
    photo: ramya,
    
  },
  {
    name: "Bharathi Raja S",
    designation: "Deputy Treasurer",
    photo: bharathi,
    
  },
  {
    name: "Sharvesh B",
    designation: "General Secretary",
    photo: sharvesh,
    linkedin: "https://www.linkedin.com/in/sharvesh-bala-152781256/",
  },
  {
    name: "Vishnu Priya K T",
    designation: "General Secretary",
    photo: vishnupriya,
    
  },
  {
    name: "Ganesh R",
    designation: "General Secretary - PG",
    photo: ganesh,
    linkedin: "https://www.linkedin.com/in/ganesh-r-14bb2727a",
  },
];

export default ObDetails;
